import { render } from "./ResetPasswordBody.vue?vue&type=template&id=528ec533&scoped=true"
import script from "./ResetPasswordBody.vue?vue&type=script&lang=js"
export * from "./ResetPasswordBody.vue?vue&type=script&lang=js"

import "./ResetPasswordBody.vue?vue&type=style&index=0&id=528ec533&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528ec533"]])

export default __exports__